import Cart from '../../components/Cart/Cart'

const CartPage = () => {
   return (
      <>
         <Cart />
      </>
   )
}

export default CartPage
